module.exports = __webpack_public_path__ + "img/alert_radio.08aa1e39.svg";